export default __webpack_public_path__ + "static/media/logo-dpr-ri.c7b479a1.png";